import { FC } from 'react'
import { Box, Typography, OutlinedInput, InputProps } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { FormControl } from './styles/controlledTextArea.styles'
import theme from '../../../theme'

const muiTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            '-webkit-background-clip': 'text !important',
            '-webkit-text-fill-color': theme.baseColors.greyscale[80]
          },
          '&::placeholder': {
            overflow: 'hidden',
            color: `${theme.baseColors.secondary[80]} !important`,
            '-webkit-text-fill-color': `${theme.baseColors.secondary[80]} !important`,
            textOverflow: 'ellipsis',
            fontSize: theme.typography.fontSize.xLarge,
            fontStyle: 'normal',
            fontWeight: theme.typography.fontWeight.normal,
            lineHeight: 'normal',
            opacity: '1 !important'
          }
        },
        root: {
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors.errorLight
          }
        }
      }
    }
  }
})

type Props = InputProps & {
  name: string
  label: string
  value: string
  helperText?: string
  variant?: 'standard' | 'outlined' | 'filled'
  showAsterisk?: boolean
  counterLimit?: number
}

const ControlledTextArea: FC<Props> = ({
  label,
  variant,
  helperText,
  value,
  showAsterisk = true,
  counterLimit,
  ...rest
}) => {
  const hasError = Boolean(helperText)
  const isOverLimit = counterLimit ? value.length > counterLimit : false

  return (
    <ThemeProvider theme={muiTheme}>
      <FormControl
        variant={variant || 'standard'}
        className="text-field-custom-label-form-control"
        iserrored={hasError ? 'true' : 'false'}
      >
        <Typography className="form-control-label">
          {label}
          {showAsterisk && <span>*</span>}
        </Typography>
        <OutlinedInput value={value} error={hasError} {...rest} />
        {helperText && <Typography className={`helper-text ${hasError ? 'error-text' : ''}`}>{helperText}</Typography>}
        {typeof counterLimit !== 'undefined' && (
          <Box className="char-counter">
            <Typography className={`char-counter-text ${isOverLimit ? 'text-danger' : ''}`}>
              {value.length}/{counterLimit}
            </Typography>
          </Box>
        )}
      </FormControl>
    </ThemeProvider>
  )
}

export default ControlledTextArea
